import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { ui } from '@/constants';
import { AnalyticsEventAction, AnalyticsEventCategory, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
  name: 'CmgLoyaltyProgressWalletStickyHeader',
})
export default class CmgLoyaltyProgressWalletStickyHeader extends Vue {
  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get medallionReward(): string {
    return this.$appStore.state.cms.images.logos.medallionReward.default;
  }

  get pointsBalance(): number {
    return this.$services.reward.getPointsBalance();
  }

  get numRewards(): number {
    return this.$services.reward.getNumRedeemableRewards();
  }

  get numRewardsStr(): string {
    return this.$services.reward.getNumRedeemableRewardsStr();
  }

  get isOnRewardsExchangePage(): boolean {
    return this.$route.name == Routes.RewardsExchange;
  }

  onClickRewardsExchange() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.RewardExchangeClick,
      label: AnalyticsEventLabel.RewardsRewardExchangeClick,
    });
    this.$router.push({ name: Routes.RewardsExchange });
  }

  onClickScanReminder() {
    this.$router.push({ name: Routes.RetroCredit });
  }

  onClickPointsHistory() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsStore,
      action: AnalyticsEventAction.ViewPointHistoryClick,
      label: AnalyticsEventLabel.PointHistoryClick,
    });
    this.$services.ui.nextFocus('points');
    this.$router.push({ name: Routes.RewardsPointsHistory });
  }
}
